// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a7660db8","267":"df72e6a4","632":"63eb436f","679":"cb21df9f","766":"5d0955e6","836":"cba425ff"}[chunkId] + ".chunk.js";
};